import { Row } from 'antd';
import styled from 'styled-components';

export const RowSpaced = styled(Row)`
  margin-bottom: 2.5rem;
`;
